import styled from "styled-components";
import Text from "./Text";

const SmallText = styled(Text)`
  font-size: 0.75em;
`;

export default SmallText;
